import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { fetchRoomApiCall } from "./roomTypeService";
import { errorToast } from "../../../components/toastmessage/toastmessage";


const useRoomTypeTableHook = () => {
    const navigate = useNavigate();
    const [roomTypeState, setRoomTypeState] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const fetchRoomType = async () => {
            setLoader(true)
            try {
                let result = await fetchRoomApiCall();
                if (result.status === 200) {
                    setLoader(false)
                    setRoomTypeState(result?.data?.result)
                }
            } catch (e) {
                setLoader(false)
                errorToast("Failed to fetch Rooms")
            }

        }
        fetchRoomType();

    }, []);

    const handleDelete = (e, id) => {
        e.preventDefault();
        setRoomTypeState(oldValues => {
            return oldValues.filter(room => room?.uniqueId !== id?.uniqueId)
          });
    };

    const handleGetRowId = (e) => {
        return e?.uniqueID
    }

    const handleAddRooms = () => {
        navigate("/master/add-room-type")
    }
    return {
        roomTypeState,
        loader,
        handleAddRooms,
        handleGetRowId,
        handleDelete
    }


};


export default useRoomTypeTableHook;
